import React, { FC } from 'react';
import styled from 'styled-components';
import { ApprovalRequestApproved } from 'api/notifications/meta';
import { ReactComponent as Approved } from 'assets/svgs/approved.svg';
import { useTranslation } from 'hooks/use-translation';
import { ApprovalComment } from './approval-comment';

const ApprovedIcon = styled(Approved)`
  color: var(--green-50);
  width: 16px;
`;

export const ApprovalApprovedComment: FC<{ meta: ApprovalRequestApproved }> = ({
  meta: { message },
}) => {
  const fallback = useTranslation('approvals.approved');

  return (
    <ApprovalComment
      content={message?.content ?? fallback}
      icon={<ApprovedIcon />}
      background="var(--green-10)"
    />
  );
};
